/**
 * 会议纪要模板类型枚举
 */
export enum TemplateType {
  CUSTOM = '自定义模板',
  DEEP = '深度纪要',
  DIALOGUE = '对话式纪要',
  KEY_POINTS = '关键点式纪要',
  TASK_ASSIGNMENT = '任务分配'
}